export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  ORG_ADMIN: 'ROLE_ORG_ADMIN',
  CUST_ADMIN: 'ROLE_CUSTOMER_ADMIN',
  VENDOR_ADMIN: 'ROLE_VENDOR_ADMIN',
  VENDOR_USER: 'ROLE_VENDOR_USER',
  QC_USER: 'ROLE_QC'
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
